import { number } from "./../types/number";

export default function subtract(a, b) {
  a = number(a);
  b = number(b);
  return a - b;
}
